import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  Modal
} from "react-bootstrap";
import DealStatuses from "../Actions/dealStatuses";
import TCSActions from "../Actions/tcsActions";
import AuthContext from "../auth-context";
import ConfirmButton from "../Shared/ConfirmButton";
import ConfirmTCSModal from "../TCS/ConfirmTCSModal";
import NotPresentedModal from "../TCS/NotPresentedModal";
import RescheduleAsNewDealModal from "./RescheduleAsNewDealModal";
import SaleMadeModal from "./SaleMadeModal";
import NoSaleModal from "./NoSaleModal";
import PutOnHoldModal from "./PutOnHoldModal";

class TCSButtonBar extends Component {
  static contextType = AuthContext;

  state = {};

  handleConfirmModal = response => {
    this.closeModals();
    if (this.props.handleDealUpdated) this.props.handleDealUpdated(response);
  };

  handleOutcomeConfirm = response => {
    this.closeModals();
    if (this.props.handleDealUpdated && response && response.deal) {
      this.props.handleDealUpdated(response.deal);
    }
  };

  backToOutcomeChooser = () => {
    this.setState({
      showModalSaleMade: false,
      showModalNoSale: false,
      showModalPutOnHold: false,
      showOutcomeChooser: true
    });
  };

  closeModals = () => {
    this.setState({
      showModalConfirm: false,
      showModalNotPresented: false,
      showModalNeedRefresh: false,
      showRescheduleAsNewDealModal: false,
      showOutcomeChooser: false,
      showModalSaleMade: false,
      showModalNoSale: false,
      showModalPutOnHold: false
    });
  };

  render() {
    const authStore = this.context;
    const { deal, handleDealUpdated, reloadDeal } = this.props;
    const isAdmin = authStore.hasRole("admin");
    const isRestrictedCoach = authStore.hasRole("coach_restricted");

    const actions = new TCSActions(deal, handleDealUpdated, authStore);
    const dealStatuses = new DealStatuses(deal, authStore);
    const showButtons = dealStatuses.tcsStatuses.buttons;
    const statuses = dealStatuses.tcsStatuses.statuses;

    const bookTCS = as => {
      this.setState({ showModalNeedRefresh: true });
      actions.bookTCS(as);
    };

    const reschedule = (
      create_new_deal,
      assign_deal_to_me,
      admin_resheduling
    ) => {
      this.setState({ showModalNeedRefresh: true });
      actions.tcsReschedule(
        create_new_deal,
        assign_deal_to_me,
        admin_resheduling
      );
    };

    return (
      <div style={{ marginTop: 6 }}>
        <ButtonToolbar>
          {!statuses.dealCompleted && showButtons.bookTCS && (
            <DropdownButton
              style={{ marginBottom: 2 }}
              id="booktcs"
              bsStyle="info"
              bsSize="xsmall"
              title="Book TCS"
              key="booktcs"
            >
              <MenuItem onClick={() => bookTCS("seminar")}>
                As Seminar booking
              </MenuItem>
              <MenuItem onClick={() => bookTCS("web")}>As Web booking</MenuItem>
              <MenuItem onClick={() => bookTCS("call_centre")}>
                As Call centre booking
              </MenuItem>
            </DropdownButton>
          )}

          {!statuses.dealCompleted && showButtons.tcsMarkAttendeeConfirmed && (
            <Button
              bsStyle="info"
              bsSize="xsmall"
              onClick={() => this.setState({ showModalConfirm: true })}
            >
              Attendee Confirmed
            </Button>
          )}
          {!statuses.dealCompleted && showButtons.tcsPresented && (
            <ConfirmButton
              text="Presented"
              requireNote={true}
              minLength={15}
              okAction={note =>
                actions
                  .tcsPresented(note)
                  .then(() => this.setState({ showOutcomeChooser: true }))
              }
            />
          )}
          {!statuses.dealCompleted && showButtons.tcsNotPresented && (
            <Button
              bsStyle="info"
              bsSize="xsmall"
              onClick={() => this.setState({ showModalNotPresented: true })}
            >
              Could Not Present
            </Button>
          )}
          {isAdmin && showButtons.tcsReschedule && (
            <Button
              bsStyle="info"
              bsSize="xsmall"
              onClick={() => reschedule(true, false, isAdmin)}
            >
              Reschedule
            </Button>
          )}
          {isAdmin && showButtons.undoPresented && (
            <ConfirmButton
              text="Undo Presentation"
              hideNote={true}
              okAction={() => actions.undoPresentation()}
            />
          )}
          {isAdmin && showButtons.undoNoSale && (
            <ConfirmButton
              text="Undo No Sale"
              hideNote={true}
              okAction={() => actions.undoNoSale()}
            />
          )}
          {isAdmin && showButtons.undoAttendeeConfirmation && (
            <ConfirmButton
              text="Undo Confirmation"
              hideNote={true}
              okAction={() => actions.undoAttendeeConfirmation()}
            />
          )}
          {isAdmin && showButtons.undoDeadDeal && (
            <ConfirmButton
              text="Undo Dead Deal"
              hideNote={true}
              okAction={() => actions.undoDeadDeal()}
            />
          )}
          {!isAdmin && !statuses.tcsPresented &&
            (statuses.tcsCompleted || statuses.dealCompleted) && (
              <Button
                bsStyle="info"
                bsSize="xsmall"
                onClick={
                  isRestrictedCoach
                    ? () =>
                        this.setState({ showRescheduleAsNewDealModal: true })
                    : () => reschedule(true, false, isAdmin)
                }
              >
                Reschedule as new deal
              </Button>
            )}
        </ButtonToolbar>

        <NotPresentedModal
          showModal={this.state.showModalNotPresented}
          deal={deal}
          onConfirmModal={this.handleConfirmModal}
          onCloseModal={() => this.closeModals()}
        />
        <ConfirmTCSModal
          showModal={this.state.showModalConfirm}
          deal={deal}
          onConfirmModal={this.handleConfirmModal}
          onCloseModal={() => this.closeModals()}
        />
        <RescheduleAsNewDealModal
          showModal={this.state.showRescheduleAsNewDealModal}
          onCloseModal={() => this.closeModals()}
          actions={actions}
        />
        <Modal
          show={this.state.showOutcomeChooser}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>How did the session go?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Now that this session is marked as presented, please record the
              outcome.
            </p>
            <ButtonToolbar>
              <Button
                bsStyle="success"
                onClick={() =>
                  this.setState({
                    showOutcomeChooser: false,
                    showModalSaleMade: true
                  })
                }
              >
                Sale Made
              </Button>
              <Button
                bsStyle="warning"
                onClick={() =>
                  this.setState({
                    showOutcomeChooser: false,
                    showModalPutOnHold: true
                  })
                }
              >
                On Hold
              </Button>
              <Button
                bsStyle="danger"
                onClick={() =>
                  this.setState({
                    showOutcomeChooser: false,
                    showModalNoSale: true
                  })
                }
              >
                No Sale
              </Button>
            </ButtonToolbar>
          </Modal.Body>
        </Modal>

        <SaleMadeModal
          showModal={this.state.showModalSaleMade}
          deal={deal}
          saleType="sale"
          onConfirmModal={this.handleOutcomeConfirm}
          onCloseModal={this.backToOutcomeChooser}
        />
        <PutOnHoldModal
          showModal={this.state.showModalPutOnHold}
          deal={deal}
          onConfirmModal={this.handleOutcomeConfirm}
          onCloseModal={this.backToOutcomeChooser}
        />
        <NoSaleModal
          showModal={this.state.showModalNoSale}
          deal={deal}
          noSaleType="no_sale"
          onConfirmModal={this.handleOutcomeConfirm}
          onCloseModal={this.backToOutcomeChooser}
        />

        <Modal
          show={this.state.showModalNeedRefresh}
          onHide={() => reloadDeal() & this.closeModals()}
          bsSize="large"
        >
          <Modal.Header closeButton>
            <Modal.Title>Updating Coaching Session</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              After you have booked or rescheduled a TCS, the deal will need to
              be reloaded
            </p>
            <div>
              <Button
                bsStyle="success"
                bsSize="small"
                onClick={() => reloadDeal() & this.closeModals()}
              >
                Reload Now
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default TCSButtonBar;
